import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment/moment";
import { useSelector } from "react-redux";
import { selectCurrentLanguage } from "../store/reducers/languageReducer";
import { categoriesApi } from "../store/actions/campaign";
import { translate } from "../utils";
import { webSettingsData } from "../store/reducers/websettingsReducer";
import { settingsData } from "../store/reducers/settingsReducer";
import ShareButton from "./ShereButton";
import "./pt-home.css";

const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

const Footer = () => {
    const [categories, setCategories] = useState([]);

    const currentLanguage = useSelector(selectCurrentLanguage);
    const websettings = useSelector(webSettingsData);
    const settings = useSelector(settingsData);

    useEffect(() => {
        categoriesApi(
            "0",
            "8",
            currentLanguage.id,
            (response) => setCategories(Array.isArray(response?.data) ? response.data : []),
            () => setCategories([])
        );
    }, [currentLanguage]);

    const usefulLinks = [
        { to: "/", label: translate("home") },
        { to: "/view-all/24", label: "Newspaper Coverage" },
        { to: "/video-news-view/27", label: "Video Gallery" },
        { to: "/gallery-image", label: "Photo Gallery" },
        settings?.live_streaming_mode === "1" ? { to: "/live-news", label: translate("livenews") } : null,
        settings?.breaking_news_mode === "1" ? { to: "/breaking-news-view", label: translate("breakingnews") } : null,
        { to: "/more-pages", label: translate("More Pages") },
        { to: "/donationform", label: translate("Donate") },
    ].filter(Boolean);

    return (
        <footer className="pt-footer">
            <div className="container">
                <div className="pt-footer-grid">
                    {/* Brand */}
                    <div className="pt-footer-brand">
                        <Link to="/" onClick={scrollToTop} className="pt-footer-logo">
                            {websettings?.web_footer_logo ? (
                                <img src={websettings.web_footer_logo} alt={websettings?.web_name || "logo"} />
                            ) : (
                                <span>{websettings?.web_name}</span>
                            )}
                        </Link>
                        {websettings?.web_footer_description ? (
                            <p className="pt-footer-desc">{websettings.web_footer_description}</p>
                        ) : null}
                    </div>

                    {/* Categories */}
                    {categories.length > 0 ? (
                        <nav className="pt-footer-col" aria-label={translate("newscategories")}>
                            <h3 className="pt-footer-title">{translate("newscategories")}</h3>
                            <ul className="pt-footer-links pt-footer-links--two">
                                {categories.map((element) => (
                                    <li key={element.id}>
                                        <Link to={`/categories-view/${element.id}`} onClick={scrollToTop}>
                                            {element.category_name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    ) : null}

                    {/* Useful links */}
                    <nav className="pt-footer-col" aria-label={translate("usefulllinks")}>
                        <h3 className="pt-footer-title">{translate("usefulllinks")}</h3>
                        <ul className="pt-footer-links">
                            {usefulLinks.map((l) => (
                                <li key={l.to}>
                                    <Link to={l.to} onClick={scrollToTop}>
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    {/* Social */}
                    <div className="pt-footer-col">
                        <h3 className="pt-footer-title">Connect With Us</h3>
                        <div className="pt-footer-social">
                            <ShareButton />
                        </div>
                    </div>
                </div>
            </div>

            <div className="pt-footer-bottom">
                <div className="container pt-footer-bottom-inner">
                    <p>
                        {translate("copyright")} © {moment().year()} {websettings?.web_name}. {translate("allrights")}
                    </p>
                    <button type="button" className="pt-footer-top" onClick={scrollToTop} aria-label="Back to top">
                        ↑ Top
                    </button>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
